(function() {
  var script = document.currentScript;
  var guide = script ? script.previousElementSibling : null;

  while (guide && (!guide.classList || !guide.classList.contains('mm-care-guide-wrapper'))) {
    guide = guide.previousElementSibling;
  }

  var desktopAnchor = guide ? guide.previousElementSibling : null;
  var mobileMql = window.matchMedia('(max-width: 767px)');
  var desktopGridMql = window.matchMedia('(min-width: 1001px)');
  var article = guide ? guide.closest('article.product--outer') : null;
  var layoutFrame = 0;
  var observedBuybox = null;
  var buyboxLayoutObserver = null;
  var requestLayoutFrame = window.requestAnimationFrame || function(callback) {
    return window.setTimeout(callback, 16);
  };

  if (!guide || !desktopAnchor || !desktopAnchor.hasAttribute('data-care-guide-desktop-anchor')) return;

  var getMobileSlot = function() {
    return document.querySelector('[data-mpdp-care-guide-slot]');
  };

  var dispatchRepositioned = function() {
    document.dispatchEvent(new CustomEvent('mm:care-guide-repositioned', { bubbles: true }));
  };

  var deferCareGuideVideoSources = function(root) {
    if (!root) return;

    Array.prototype.forEach.call(
      root.querySelectorAll('iframe.video-embed, iframe[data-care-guide-lazy-src], iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"], iframe[src*="youtu.be"]'),
      function(iframe) {
        if (iframe.getAttribute('data-care-guide-video-loaded') === 'true') return;

        var src = iframe.getAttribute('data-care-guide-lazy-src') || iframe.getAttribute('src') || '';
        if (!src || src.indexOf('youtube') === -1 && src.indexOf('youtu.be') === -1) return;

        iframe.setAttribute('data-care-guide-lazy-src', src);
        iframe.setAttribute('data-care-guide-video-deferred', 'true');
        iframe.removeAttribute('src');
        iframe.removeAttribute('allow');
        iframe.hidden = true;
      }
    );
  };

  var getCareGuideRoot = function() {
    return guide.querySelector('#mm-care-guide');
  };

  var queryLayoutElement = function(selector) {
    if (article) {
      var scoped = article.querySelector(selector);
      if (scoped) return scoped;
    }

    return document.querySelector(selector);
  };

  var getGridColumnGap = function(grid) {
    if (!grid || !window.getComputedStyle) return 0;

    var gridStyles = window.getComputedStyle(grid);
    return parseFloat(gridStyles.columnGap || gridStyles.gap) || 0;
  };

  var observeBuyboxLayout = function(buybox) {
    if (!buybox || !window.MutationObserver) return;
    if (observedBuybox === buybox) return;

    if (buyboxLayoutObserver) {
      buyboxLayoutObserver.disconnect();
    }

    observedBuybox = buybox;
    buyboxLayoutObserver = new MutationObserver(scheduleDesktopCareGuideLayout);
    buyboxLayoutObserver.observe(buybox, {
      attributes: true,
      attributeFilter: ['data-buybox-fixed', 'data-buybox-locked', 'class']
    });
  };

  var syncDesktopCareGuideLayout = function() {
    if (mobileMql.matches) {
      guide.style.removeProperty('--mm-care-guide-left-offset');
      guide.style.removeProperty('--mm-care-guide-content-width');
      return;
    }

    var grid = queryLayoutElement('.enhanced-product-grid');
    var gallery = queryLayoutElement('.enhanced-product-grid > .product-gallery-wrapper') || queryLayoutElement('.product-gallery-wrapper');
    var middle = queryLayoutElement('.enhanced-product-grid > .product-middle') || queryLayoutElement('.product-middle');
    var buybox = queryLayoutElement('.enhanced-product-grid > .product-buybox') || queryLayoutElement('.product-buybox');
    var contentBlock = guide.querySelector('.product-page-block');

    if (!gallery || !contentBlock || !guide.parentNode) return;

    var guideRect = guide.getBoundingClientRect();
    var galleryRect = gallery.getBoundingClientRect();
    var middleRect = middle ? middle.getBoundingClientRect() : null;
    var buyboxRect = buybox ? buybox.getBoundingClientRect() : null;
    var columnGap = getGridColumnGap(grid);
    var guideStyles = window.getComputedStyle ? window.getComputedStyle(guide) : null;
    var guidePaddingLeft = guideStyles ? parseFloat(guideStyles.paddingLeft) || 0 : 0;
    var rightEdge = galleryRect.right;

    if (middleRect && middleRect.right > rightEdge && middleRect.left >= galleryRect.left) {
      rightEdge = middleRect.right;
    }

    if (buyboxRect && buyboxRect.width > 0 && buyboxRect.left > galleryRect.left) {
      rightEdge = Math.min(rightEdge, Math.max(galleryRect.right, buyboxRect.left - Math.max(12, columnGap)));
    }

    var viewportWidth = document.documentElement.clientWidth || window.innerWidth || rightEdge;
    var leftOffset = Math.max(0, Math.round(galleryRect.left - guideRect.left - guidePaddingLeft));
    var contentWidth = Math.max(320, Math.round(rightEdge - galleryRect.left));
    var maxWidth = Math.max(320, Math.round(viewportWidth - galleryRect.left - 12));

    guide.style.setProperty('--mm-care-guide-left-offset', leftOffset + 'px');
    guide.style.setProperty('--mm-care-guide-content-width', Math.min(contentWidth, maxWidth) + 'px');
    observeBuyboxLayout(buybox);
  };

  var scheduleDesktopCareGuideLayout = function() {
    if (layoutFrame) return;

    layoutFrame = requestLayoutFrame(function() {
      layoutFrame = 0;
      syncDesktopCareGuideLayout();
    });
  };

  var replaceHeroTree = function() {
    var careGuide = getCareGuideRoot();
    var heroInner = careGuide ? careGuide.querySelector('.hero-inner') : null;
    var heroSrc = guide.getAttribute('data-care-guide-hero-image');

    if (!heroInner || !heroSrc) return;

    var image = heroInner.querySelector('.mm-care-guide-hero-image');
    var sourceSvg = null;

    for (var i = 0; i < heroInner.children.length; i += 1) {
      if (heroInner.children[i].tagName && heroInner.children[i].tagName.toLowerCase() === 'svg') {
        sourceSvg = heroInner.children[i];
        break;
      }
    }

    if (!image) {
      image = document.createElement('img');
      image.className = 'mm-care-guide-hero-image';

      if (sourceSvg && sourceSvg.parentNode) {
        sourceSvg.parentNode.replaceChild(image, sourceSvg);
      } else {
        heroInner.insertBefore(image, heroInner.firstChild);
      }
    } else if (sourceSvg && sourceSvg.parentNode) {
      sourceSvg.parentNode.removeChild(sourceSvg);
    }

    image.alt = guide.getAttribute('data-care-guide-hero-alt') || '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.srcset = guide.getAttribute('data-care-guide-hero-srcset') || '';
    image.sizes = '(max-width: 767px) 74px, 120px';
    image.src = heroSrc;
  };

  var getCardIconName = function(card) {
    var title = card.querySelector('h3');
    var text = ((card.id || '') + ' ' + (title ? title.textContent : '')).toLowerCase();

    if (text.indexOf('water') !== -1) return 'water';
    if (text.indexOf('soil') !== -1) return 'shovel';
    if (text.indexOf('sun') !== -1 || text.indexOf('shade') !== -1) return 'sun';
    if (text.indexOf('fertiliz') !== -1 || text.indexOf('feed') !== -1) return 'seedling';
    if (text.indexOf('prun') !== -1 || text.indexOf('maintenance') !== -1) return 'scissors';
    if (text.indexOf('winter') !== -1 || text.indexOf('frost') !== -1 || text.indexOf('cold') !== -1) return 'snowflake';
    if (text.indexOf('container') !== -1 || text.indexOf('pot') !== -1) return 'flower-tulip';
    if (text.indexOf('variety') !== -1 || text.indexOf('cultivar') !== -1 || text.indexOf('selection') !== -1) return 'leaf-maple';
    if (text.indexOf('pest') !== -1 || text.indexOf('disease') !== -1 || text.indexOf('issue') !== -1) return 'bug';

    return 'plant-growth';
  };

  var replaceCardIcons = function() {
    var careGuide = getCareGuideRoot();
    if (!careGuide) return;

    Array.prototype.forEach.call(careGuide.querySelectorAll('.card'), function(card) {
      var iconName = getCardIconName(card);
      var existingIcon = null;
      var sourceSvg = null;

      for (var i = 0; i < card.children.length; i += 1) {
        if (card.children[i].classList && card.children[i].classList.contains('mm-care-guide-card-icon')) {
          existingIcon = card.children[i];
        }

        if (!sourceSvg && card.children[i].tagName && card.children[i].tagName.toLowerCase() === 'svg') {
          sourceSvg = card.children[i];
        }
      }

      var icon = existingIcon || document.createElement('span');
      icon.className = 'mm-care-guide-card-icon';
      icon.setAttribute('data-care-guide-icon', iconName);
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '';

      if (!existingIcon && sourceSvg && sourceSvg.parentNode) {
        sourceSvg.parentNode.replaceChild(icon, sourceSvg);
      } else if (!existingIcon) {
        card.insertBefore(icon, card.firstChild);
      } else if (sourceSvg && sourceSvg.parentNode) {
        sourceSvg.parentNode.removeChild(sourceSvg);
      }
    });
  };

  var showCareGuideVideosInline = function() {
    var careGuide = getCareGuideRoot();
    if (!careGuide) return;

    var getYouTubeVideoId = function(src) {
      var match = String(src || '').match(/(?:youtube(?:-nocookie)?\.com\/embed\/|youtube\.com\/watch\?[^#]*v=|youtu\.be\/)([\w-]+)/i);
      return match ? match[1] : '';
    };

    var withAutoplay = function(src) {
      if (!src || src.indexOf('autoplay=') !== -1) return src;
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
    };

    var prepareLazyVideo = function(videoToggle) {
      var panel = videoToggle.querySelector('.video-panel');
      var iframe = panel ? panel.querySelector('iframe.video-embed, iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"], iframe[src*="youtu.be"]') : null;
      if (!panel || !iframe || iframe.getAttribute('data-care-guide-video-loaded') === 'true') return;

      var src = iframe.getAttribute('data-care-guide-lazy-src') || iframe.getAttribute('src') || '';
      if (!src || src.indexOf('youtube') === -1 && src.indexOf('youtu.be') === -1) return;

      iframe.setAttribute('data-care-guide-lazy-src', src);
      iframe.setAttribute('data-care-guide-video-deferred', 'true');
      iframe.removeAttribute('src');
      iframe.removeAttribute('allow');
      iframe.hidden = true;

      if (panel.querySelector('.mm-care-guide-video-lazy-button')) return;

      var title = iframe.getAttribute('title') || videoToggle.getAttribute('aria-label') || 'care guide video';
      var videoId = getYouTubeVideoId(src);
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mm-care-guide-video-lazy-button';
      button.setAttribute('aria-label', 'Play ' + title);
      if (videoId) {
        button.style.backgroundImage = "linear-gradient(rgba(12, 20, 10, 0.25), rgba(12, 20, 10, 0.45)), url('https://i.ytimg.com/vi/" + encodeURIComponent(videoId) + "/hqdefault.jpg')";
      }
      button.innerHTML = '<span class="mm-care-guide-video-lazy-icon" aria-hidden="true"></span><span class="mm-care-guide-video-lazy-text">Play video</span>';
      button.addEventListener('click', function() {
        iframe.hidden = false;
        iframe.removeAttribute('data-care-guide-video-deferred');
        iframe.setAttribute('data-care-guide-video-loaded', 'true');
        iframe.setAttribute('src', withAutoplay(src));
        button.remove();
      });
      panel.insertBefore(button, iframe);
    };

    Array.prototype.forEach.call(careGuide.querySelectorAll('.video-toggle'), function(videoToggle) {
      var panel = videoToggle.querySelector('.video-panel');

      videoToggle.open = true;
      videoToggle.setAttribute('data-open', 'true');
      videoToggle.setAttribute('data-care-guide-video-inline', 'true');

      if (panel) {
        panel.hidden = false;
        panel.removeAttribute('hidden');
      }

      prepareLazyVideo(videoToggle);
    });
  };

  var hydrateCareGuidePresentation = function() {
    replaceHeroTree();
    replaceCardIcons();
    showCareGuideVideosInline();
  };

  var loadCareGuideFallback = function() {
    if (!guide || guide.getAttribute('data-care-guide-loaded') === 'true' || guide.getAttribute('data-care-guide-loading') === 'true') return;

    var handle = guide.getAttribute('data-care-guide-handle');
    if (!handle) return;

    guide.setAttribute('data-care-guide-loading', 'true');

    fetch('/pages/' + encodeURIComponent(handle), { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Care guide page request failed');
        }
        return response.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var careGuide = doc.querySelector('#mm-care-guide');
        var pageContent = careGuide || doc.querySelector('.page__content[data-rte]') || doc.querySelector('.page__content');

        if (!pageContent) {
          throw new Error('Care guide content not found');
        }

        var block = document.createElement('div');
        block.className = 'product-page-block product-page-block--' + handle;

        var rte = document.createElement('div');
        rte.className = 'page__content rte';
        rte.setAttribute('data-rte', '');

        if (careGuide) {
          var clonedCareGuide = careGuide.cloneNode(true);
          deferCareGuideVideoSources(clonedCareGuide);
          rte.appendChild(clonedCareGuide);
        } else {
          rte.innerHTML = pageContent.innerHTML;
          deferCareGuideVideoSources(rte);
        }

        block.appendChild(rte);
        guide.innerHTML = '';
        guide.appendChild(block);
        guide.setAttribute('data-care-guide-loaded', 'true');
        guide.removeAttribute('data-care-guide-loading');
        hydrateCareGuidePresentation();
        scheduleDesktopCareGuideLayout();
        dispatchRepositioned();
      })
      .catch(function() {
        var fallback = guide.querySelector('[data-care-guide-fallback]');
        guide.removeAttribute('data-care-guide-loading');
        guide.setAttribute('data-care-guide-error', 'true');

        if (fallback) {
          fallback.hidden = false;
        }
      });
  };

  var restoreToAnchor = function() {
    if (desktopAnchor.parentNode && guide.previousElementSibling !== desktopAnchor) {
      desktopAnchor.parentNode.insertBefore(guide, desktopAnchor.nextSibling);
    }
  };

  var placeDesktopCareGuide = function() {
    var grid = queryLayoutElement('.enhanced-product-grid');
    var middle = queryLayoutElement('.enhanced-product-grid > .product-middle');

    if (!grid || !middle || middle.parentNode !== grid) {
      restoreToAnchor();
      return;
    }

    if (desktopAnchor.parentNode !== grid || desktopAnchor.previousElementSibling !== middle) {
      grid.insertBefore(desktopAnchor, middle.nextSibling);
    }

    if (guide.parentNode !== grid || guide.previousElementSibling !== desktopAnchor) {
      grid.insertBefore(guide, desktopAnchor.nextSibling);
    }
  };

  var placeCareGuide = function() {
    var mobileSlot = getMobileSlot();

    if (mobileMql.matches && mobileSlot) {
      if (guide.parentNode !== mobileSlot) {
        mobileSlot.appendChild(guide);
      }
      guide.classList.add('mm-care-guide-wrapper--mobile');
    } else if (desktopGridMql.matches) {
      placeDesktopCareGuide();
      guide.classList.remove('mm-care-guide-wrapper--mobile');
    } else if (desktopAnchor.parentNode) {
      restoreToAnchor();
      guide.classList.remove('mm-care-guide-wrapper--mobile');
    }

    hydrateCareGuidePresentation();
    scheduleDesktopCareGuideLayout();
    dispatchRepositioned();
  };

  placeCareGuide();
  loadCareGuideFallback();

  if (typeof mobileMql.addEventListener === 'function') {
    mobileMql.addEventListener('change', placeCareGuide);
  } else if (typeof mobileMql.addListener === 'function') {
    mobileMql.addListener(placeCareGuide);
  }

  if (typeof desktopGridMql.addEventListener === 'function') {
    desktopGridMql.addEventListener('change', placeCareGuide);
  } else if (typeof desktopGridMql.addListener === 'function') {
    desktopGridMql.addListener(placeCareGuide);
  }

  document.addEventListener('mpdp:reviews-hoisted', placeCareGuide);
  window.addEventListener('load', placeCareGuide, { once: true });
  window.addEventListener('resize', scheduleDesktopCareGuideLayout);
})();
